module.exports = __webpack_public_path__ + "img/cricket.31ce047a.svg";